// extracted by mini-css-extract-plugin
module.exports = {"fontSizeH5":"Popup_fontSizeH5__yuz_y"};